export default {
    list: {
        title: 'Team',
        subtitle: 'Manage team members',
        invite: 'Invite Member',
        loading: 'Loading team...',
        addMember: 'Add Member',
        allRoles: 'All roles',
        allStatuses: 'All statuses',
        searchPlaceholder: 'Search by name or email...',
        rolePlaceholder: 'Filter by role',
        statusPlaceholder: 'Filter by status',
        description: 'List of your team members',
        headers: {
            name: 'Name',
            email: 'Email',
            role: 'Role',
            status: 'Status',
            lastLogin: 'Last Login',
            inviteDate: 'Invite Date',
            actions: 'Actions',
        },
        noMembers: {
            title: 'No team members found',
            message: 'Try modifying the search filters',
            emptyMessage: 'Start by adding your first team member',
            addFirst: 'Add First Member',
        },
        modal: {
            addTitle: 'Add Member',
            editTitle: 'Edit Member',
            fields: {
                name: 'Name',
                namePlaceholder: 'Enter name',
                email: 'Email',
                emailPlaceholder: 'name@company.com',
                role: 'Role',
                rolePlaceholder: 'Select role',
                status: 'Status',
                statusPlaceholder: 'Select status',
            },
            cancel: 'Cancel',
            save: 'Save',
            create: 'Create',
        },
        statusLabels: {
            active: 'Active',
            inactive: 'Inactive',
        },
        never: 'Never',
        confirmDelete: 'Are you sure you want to delete this team member?',
    },
};
